import React from 'react';
import DraggableCard from '../../tc-ui/sortable-list-with-react-dnd/draggable-card';
import SortableList from '../../tc-ui/sortable-list-with-react-dnd/sortable-list';
import { FontIcon, Dialog, FlatButton } from 'material-ui';
import injectSheet from 'react-jss';
import R from 'ramda';

const styles = {
  draggableCard: { margin: '0px 0px 8px 32px', width: '90%' },
  sortableItem: { border: '1px dashed rgba(0, 0, 0, 0.54)', padding: '12px 6px' },
  selectFieldStyle: { width: '80%', marginLeft: '32px' },
  text: { display: 'inline-block', width: '80%', marginLeft: '6px', position: 'relative', top: '-2px', cursor: 'pointer' },
};

class ReorderItems extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      items: props.items || [],
    };
  }

  componentWillReceiveProps(nextProps) {
    if (!R.equals(this.props.items, nextProps.items)) {
      this.setState({ items: nextProps.items });
    }
  }

  _onDragEnds = (vals) => {
    this.setState({ items: vals });
  }

  _updateOrder = () => {
    this.props.updateOrder(this.state.items);
  }

  render() {
    const {
      onRequestClose,
      classes = {},
      open,
      savingChanges,
    } = this.props;
    const {
      items = [],
    } = this.state;
    return (
      <Dialog
        open={open}
        autoScrollBodyContent
        title="Reorder List"
        contentStyle={{ display: 'flex', justifyContent: 'center', flexDirection: 'column', padding: '32px' }}
        actions={[
          <FlatButton
            label="cancel"
            onTouchTap={onRequestClose}
            primary
          />,
          <FlatButton
            label={savingChanges ? 'saving' : 'confirm'}
            disabled={savingChanges || !items.length}
            onTouchTap={this._updateOrder}
            secondary
          />,
        ]}
      >
        <p> Drag and drop to reorder.</p>
        <SortableList
          style={{ width: '85%' }}
          arrayOfData={this.state.items}
          dragEnds={this._onDragEnds}
        >
          {
            this.state.items.map((item, i) => (
              <DraggableCard key={item.id} className={classes.draggableCard} isDragSource isDropTarget>
                <div className={classes.sortableItem}>
                  <div className={classes.text}>{item.name}</div>
                  <FontIcon className="tc-icon-swap_vert" style={{ color: 'rgba(0, 0, 0, 0.34)', top: '5px' }}/>
                </div>
              </DraggableCard>))
          }
        </SortableList>
      </Dialog>
    );
  }
}

ReorderItems.propTypes = {
  items: React.PropTypes.array,
  classes: React.PropTypes.object,
  onRequestClose: React.PropTypes.func,
  open: React.PropTypes.bool,
  savingChanges: React.PropTypes.bool,
  updateOrder: React.PropTypes.func,
};

export default injectSheet(styles)(ReorderItems);



// WEBPACK FOOTER //
// ./src/app/components/profile/location-or-product-list/reorder-items.jsx